export enum EntityReferenceType {
    Invoice = 'invoice',
    Checkout = 'checkout',
    Payout = 'payout',
    Charge = 'charge',
    CurrencyConversion = 'currency-conversion',
}
